<template>
<section>
    <div v-if="loading" class="content content-centered">
        <pulse-loader></pulse-loader>
    </div>
    <div v-show="!loading" class="content">
        <div class="box">
            <div class="box-body">
                <div class="row">
                    <div class="flash-message col-md-4 col-md-offset-4 text-center" v-if="flash">
                        <div class="alert" :class="'alert-' + flashType">
                            {{ flashMessage }}
                        </div>
                    </div>
                </div>
                <div id="details">
                    <vue-form :state="formstate" @submit.prevent="onSubmit" class="row">
                        <div class="col-sm-12">
                            <div class="paddi_class_colm">
                            <h4>Trip Location</h4>
                            <div class="col-sm-4">
                                <validate auto-label class="form-group required-field" :class="fieldClassName(formstate.cityId)">
                                    <label>City Name</label>
                                    <select required name="cityId" class="form-control" v-model="trip.cityId" :disabled="isCityDisable" v-on:change="getCityId($event.target.value)">
                                        <option value="" disabled>Select City Name</option>
                                        <option v-for="cityId in cities" :value="cityId.id" :selected="
                          cityId && trip.cityId && cityId.id === trip.cityId
                        ">{{ cityId.name }}
                                        </option>
                                    </select>
                                    <field-messages name="cityId" show="$touched || $submitted" class="form-control-feedback">
                                        <div slot="required">This is required field</div>
                                    </field-messages>
                                </validate>
                            </div>
                            <div class="col-sm-4">
                                <validate auto-label class="form-group required-field" :class="fieldClassName(formstate.transportPoint)">
                                    <label>Transport Point</label>
                                    <select v-model="trip.tId" name="transportPoint" required class="form-control">
                                        <option value="" disabled>Select Transport Point</option>
                                        <option v-for="(item, index) in transferListData" :key="index" :value="item._id" :selected="item && trip.tId && trip.tId === item._id">
                                            {{ item.transportName }}
                                        </option>
                                    </select>
                                    <field-messages name="transportPoint" show="$touched || $submitted" class="form-control-feedback">
                                        <div slot="required">
                                            Segregation Plant is a required field
                                        </div>
                                    </field-messages>
                                </validate>
                            </div>
                            <div class="col-sm-4">
                                <validate auto-label class="form-group required-field" :class="fieldClassName(formstate.segregationOrDumpYard)">
                                    <label>Segregation Plant / Dump Yard</label>
                                    <select v-model="trip.SpDyId" required name="segregationOrDumpYard" class="form-control">
                                        <option value="" disabled>Select Segregation Plant / Dump Yard</option>
                                        <option v-for="(item, index) in segDyData" :key="index" :value="item._id" :selected="
                          item.id && trip.SpDyId && item.id === trip.SpDyId
                        ">
                                            {{ item.plantName }} - {{ item.name }}
                                        </option>
                                    </select>
                                    <field-messages name="segregationOrDumpYard" show="$touched || $submitted" class="form-control-feedback">
                                        <div slot="required">Dump Yard is a required field</div>
                                    </field-messages>
                                </validate>
                            </div>
                            </div>
                        </div>
                        <div class="col-sm-12">
                            <div class="paddi_class_colm">
                            <h4>Vehicle & Driver</h4>
                            <div class="col-sm-6">
                                <validate auto-label class="form-group required-field" :class="fieldClassName(formstate.vehicle)">
                                    <label>Vehicle</label>
                                    <select required v-model="trip.vehicleId" name="vehicle" class="form-control">
                                        <option value="" disabled>Select Vehicle</option>
                                        <option v-for="(item, index) in vehicle_name" :key="index" :value="item.id" :selected="
                          item && trip.vehicleId && item.id === trip.vehicleId
                        ">
                                            {{ item.name }}
                                        </option>
                                    </select>
                                    <field-messages name="vehicle" show="$touched || $submitted" class="form-control-feedback">
                                        <div slot="required">Vehicle is a required field</div>
                                    </field-messages>
                                </validate>
                            </div>
                            <div class="col-sm-6">
                                <validate auto-label class="form-group required-field" :class="fieldClassName(formstate.driver)">
                                    <label>Driver</label>
                                    <select required v-model="trip.driverId" name="driver" class="form-control">
                                        <option value="" disabled>Select Driver</option>
                                        <option v-for="(item, index) in driver_name" :key="index" :value="item.id" :selected="
                          item && trip.driverId && item.id === trip.driverId
                        ">
                                            {{ item.name }}
                                        </option>
                                    </select>
                                    <field-messages name="driver" show="$touched || $submitted" class="form-control-feedback">
                                        <div slot="required">Driver is a required field</div>
                                    </field-messages>
                                </validate>
                            </div>
                            </div>
                        </div>

                        <div class="col-sm-12">
                            <div class="col-sm-4">
                                <validate auto-label class="form-group required-field" :class="fieldClassName(formstate.scheduleTime)">
                                    <label>Schedule Time</label>
                                    <datetime required id="scheduleTime" type="datetime" v-model="trip.scheduleTime" :min-datetime="new Date().toISOString()" lang="en" name="scheduleTime" input-class="form-control" @input="selectDateEnable($event)" class="theme-wm" placeholder="Select Time"></datetime>
                                    <field-messages name="scheduleTime" show="$touched || $submitted" class="form-control-feedback">
                                        <div slot="required">Start date is a required field</div>
                                    </field-messages>
                                </validate>
                            </div>
                        </div>
                    </vue-form>
                    <div class="col-sm-12 text-right">
                        <a v-if="$route.params && $route.params._id =='0'">
                            <router-link :to="{ name: 'secondaryTrip' }">
                                <button class="mr-5 btn btn-default" type="button">
                                    Cancel
                                </button>
                            </router-link>
                        </a>
                        <a v-if="$route.params && $route.params._id && $route.params._id != '0'">
                            <router-link :to="{
                    name: 'secondary',
                    params: { _id: $route.params._id },
                  }">
                                <button class="mr-5 btn btn-default" type="button">
                                    Cancel
                                </button>
                            </router-link>
                        </a>
                        <button class="mr-2 btn gradientbt" type="submit" @click="createTrip" :disabled="!(formstate.$dirty && formstate.$valid) && selectDate" v-if="$route.params && $route.params._id == '0'">
                            Save
                        </button>
                        <button class="mr-2 btn gradientbt" type="submit" @click="updateTrip" :disabled="!(formstate.$dirty && formstate.$valid) && selectDate" v-if="$route.params && $route.params._id && $route.params._id !='0'">
                            Update
                        </button>
                    </div>

                </div>
            </div>
        </div>
    </div>
</section>
</template>

<script>
import {
    formService,
    eventBus,
    transportService,
    primarytripService,
    secondaryTripService,
} from "../../../services";
import {
    EVENTS
} from "../../../config";
import {
    USER_ROLES
} from "../../../config";
import {
    mapState
} from "vuex";
import secondaryTripListVue from "./secondaryTripList.vue";

export default {
    name: "createSegregationTrip",
    data() {
        return {
            isCityDisable: false,
            ready: false,
            USER_ROLES: USER_ROLES,
            loading: false,
            flash: false,
            flashType: null,
            flashMessage: "",
            EVENTS: EVENTS,
            trip: {               
                cityId: "",
                tId: "",
                SpDyId: "",
                vehicleId: "",
                driverId: "",
            },
            formstate: {},
            transport_Point: {},
            segregation_plant_dump_Yard: {},
            drivers: {},
            vehicles: {},
            cities: {},
            driver_name: null,
            vehicle_name: null,
            division_ward: [],
            segDyData: [],
            transferListData: [],
            tripStatus: "upcoming",
            selectDate: true,
        };
    },

    mounted: function () {       
        this.getCityList();
    },

    methods: {
        fieldClassName: formService.fieldClassName,

        selectDateEnable(value) {      
              if (value.length > 0) {
                    this.selectDate = false
                } else {
                    this.selectDate = true
                }
            },

        getCityList() {
            if (this.$store.state.auth.user.role.key === "cityAdmin") {
                const {
                    _id,
                    cityName
                } = this.$store.state.auth.user.cityId;
                this.cities = [{
                    id: _id,
                    name: cityName
                }];
                this.getCityId(_id)
                this.trip["cityId"] = _id;
                this.isCityDisable = true;
                return;
            }
            this.loading = true;
            const params = {};
            let cityList = [];
            this.$cityRepository
                .collectionCitysList(params)
                .then((res) => {
                    this.loading = false;
                    res.data.response.forEach((element) => {
                        if (element.status === true) {
                            cityList.push({
                                name: element.cityName,
                                id: element._id,
                            });
                        }
                    });
                    cityList.sort((item1, item2) => {
                        return item1.name.toLowerCase() < item2.name.toLowerCase() ? -1 : 1;
                    });
                    this.cities = cityList;
                })
                .catch((error) => {
                    this.loading = false;
                    console.error("cities.requestFunction-error:", error);
                    this.$snotify.error("Get cities list failed", "Error!");
                });
        },
        getCityId(cityId) {            
            this.trip.tId = '';
            this.trip.SpDyId = '';
            this.trip.vehicleId = '';
            this.trip.driverId = '';
            this.getDriverList(cityId);
            this.getVehicleList(cityId);
            this.getSpDy(cityId);
            this.getTransferList(cityId);
        },

        createTrip() {
            this.trip["collectionDataInfo"] = [];
            this.trip["tripStatus"] = this.tripStatus;
            return secondaryTripService
                .addsecondaryTrip(this.trip)
                .then((response) => {
                    this.loading = false;
                    this.flash = false;
                    this.$snotify.success("Transfer Point Trip has been added successfully.");
                    this.$router.push({
                        name: "secondary",
                        params: {
                            _id: response.data._id,
                        },
                    });
                })
                .catch((error) => {
                    this.loading = false;
                    this.$snotify.error(error.data.message, "Error!");
                });
        },

        updateTrip() {
            this.loading = true;
            return secondaryTripService
                .updateSecondaryTrip(this.trip)
                .then((response) => {
                    this.loading = false;
                    this.flash = false;
                    this.$snotify.success("Transfer Point Trip has been updated successfully.");
                    this.$router.push({
                        name: "secondary",
                        params: {
                            _id: response.data._id,
                        },
                    });
                })
                .catch((error) => {
                    this.loading = false;
                    this.$snotify.error(error.data.message, "Error!");
                });
        },

        getDriverList(id) {
            let driver_nameList = [];
            return primarytripService
                .driverList(id)
                .then((res) => {
                    res.data.response.forEach((element) => {
                        if (element.status == true) {
                            driver_nameList.push({
                                name: element.firstName + " " + element.lastName,
                                id: element._id,
                            });
                        }
                    });
                    driver_nameList.sort((item1, item2) => {
                        return item1.name.toLowerCase() < item2.name.toLowerCase() ? -1 : 1;
                    });
                    this.driver_name = driver_nameList;
                })
                .catch((error) => {
                    this.loading = false;
                    console.error("Driver.requestFunction-error:", error);
                    this.$snotify.error("Driver list failed", "Error!");
                });
        },

        getVehicleList(id) {
            let vehicle_nameList = [];
            return primarytripService
                .vehicleList(id)
                .then((res) => {
                    res.data.response.forEach((element) => {
                        if (element.status == true) {
                            if (element.vType === "Primary(Small)") {
                                vehicle_nameList.push({
                                    name: element.vNumber,
                                    id: element._id,
                                });
                            }
                        }
                    });
                    vehicle_nameList.sort((item1, item2) => {
                        return item1.name.toLowerCase() < item2.name.toLowerCase() ? -1 : 1;
                    });
                    this.vehicle_name = vehicle_nameList;
                })
                .catch((error) => {
                    this.loading = false;
                    console.error("Vehicle.requestFunction-error:", error);
                    this.$snotify.error("Vehicle list failed", "Error!");
                });
        },

        getSpDy(id) {
            let segregation_nameList = [];
            return secondaryTripService
                .getSegregationDumpyardList(id)
                .then((res) => {
                    this.loading = false;
                    let segDyDataSort = res.data.response;
                    segDyDataSort.sort((item1, item2) => {
                        return item1.name.toLowerCase() < item2.name.toLowerCase() ? -1 : 1;
                    });
                    this.segDyData = segDyDataSort;
                })
                .catch((error) => {
                    this.loading = false;
                    console.error("getSegregationDumpyardList-error:", error);
                });
        },

        getTransferList(id) {
            return secondaryTripService
                .getTransportList(id)
                .then((res) => {
                    this.loading = false;
                    let transerListSort = res.data.response;
                    transerListSort.sort((item1, item2) => {
                        return item1.transportName.toLowerCase() <
                            item2.transportName.toLowerCase() ?
                            -1 :
                            1;
                    });
                    this.transferListData = transerListSort;
                })
                .catch((error) => {
                    this.loading = false;
                    console.error("getTransferList-error:", error);
                });
        },

        getTripInfo() {
            return secondaryTripService
                .getById(this.$route.params._id)
                .then((response) => {
                    this.getDriverList(response.data.cityId._id);
                    this.getVehicleList(response.data.cityId._id);
                    this.getSpDy(response.data.cityId._id);
                    this.getTransferList(response.data.cityId._id);
                    this.trip["cityId"] = response.data.cityId._id;
                    this.trip["tId"] = response.data.tId._id;
                    this.trip["vehicleId"] = response.data.vehicleId._id;
                    this.trip["driverId"] = response.data.driverId._id;
                    this.trip["SpDyId"] = response.data.SpDyId;
                    this.trip["scheduleTime"] = response.data.scheduleTime;
                    this.trip["tripStatus"] = response.data.tripStatus;
                    this.trip["_id"] = response.data._id;
                });
        },
    },

    created() {
        const promises = [];
        this.loading = true;
       if (this.$route.params && this.$route.params._id && this.$route.params._id != '0') {
            promises.push(this.getTripInfo());
        }
        Promise.all(promises)
            .then(() => {
                this.loading = false;
                this.ready = true;
            })
            .catch(() => {
                this.loading = false;
            });
    },
};
</script>

<style>
h4 {
    font-weight: bold;
}

.required-field>label::after {
    content: "*";
    color: red;
    margin-left: 0.25rem;
}

.form-control-feedback {
    font-weight: 100;
    color: red;
    position: initial;
    text-align: left;
    height: auto;
    width: auto;
}

.has-danger {
    color: red;
}

.mt {
    margin-top: 7px;
}

.gradientbt {
    background: #0f6940;
    color: white;
}

.inputwrapper {
    position: relative;
}

.maps {
    position: absolute;
    top: 7px;
    right: 10px;
}
.paddi_class_colm h4{
    padding-left: 15px;
}
</style>



// WEBPACK FOOTER //
// createSecondaryTrip.vue?0bd1e466